import React from "react";
import Link from "gatsby-link";
import ReactTouchEvents from "react-touch-events";
import GatsbyConfig from "../../../gatsby-config.js";
import { getEl, getEls } from "../../utils/app-helpers";
import PrevNext from "../../components/partials/prev-next";

const { siteMetadata: config } = GatsbyConfig;

export default class ImageSlider extends React.Component {
  // make sure to update CSS transitions accordingly
  static AUTO_ADVANCE_DELAY = 3500;
  static ANIMATION_TIMING = 400;

  constructor() {
    super();

    this.activeIndex = 0;
    this.isBusy = false;
    this.shouldAutoAdvance = true;

    this.selectSlide = this.selectSlide.bind(this);
    this.autoAdvance = this.autoAdvance.bind(this);
    this.stopAutoAdvance = this.stopAutoAdvance.bind(this);
    this.clickNext = this.clickNext.bind(this);
    this.clickPrev = this.clickPrev.bind(this);
    this.swipe = this.swipe.bind(this);
    this.onWaitForImageLoad = this.onWaitForImageLoad.bind(this);
  }

  componentDidMount() {
    const { waitForImage } = this.props;

    if (waitForImage) return;
    this.selectSlide(0, false);
    this.autoAdvance();
  }

  componentWillUnmount() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }
    if (this.autoAdvanceTimeout) {
      clearTimeout(this.autoAdvanceTimeout);
    }
  }

  selectSlide(which, animation) {
    if (this.isBusy) return;
    const slideEls = getEls(".image-slider .slide");
    const barEls = getEls(".image-slider .bar");
    const activeSlide = getEl(".image-slider .slide.active");
    const activeBar = getEl(".image-slider .bar.active");
    const newActiveSlide = slideEls[which];
    const newActiveBar = barEls[which];
    const direction =
      animation === "auto"
        ? which > this.activeIndex
          ? "left"
          : "right"
        : animation;

    // clear animation classes
    slideEls.forEach((slideEl) => {
      slideEl.classList.remove(
        "slide-left",
        "slide-right",
        "init-left",
        "init-right"
      );
    });

    // if direction is set, trigger a new animation
    if (animation && direction && which !== this.activeIndex) {
      if (which === 0) this.stopAutoAdvance();
      newActiveSlide.classList.add(`init-${direction}`);
      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
      }
      this.animationTimeout = setTimeout(
        (() => {
          this.isBusy = true;
          if (typeof activeSlide !== "undefined") {
            activeSlide.classList.add(`slide-${direction}`);
            activeSlide.classList.remove("active");
          }
          if (typeof activeBar !== "undefined") {
            activeBar.classList.remove("active");
          }
          newActiveSlide.classList.add("active");
          newActiveSlide.classList.remove(`init-${direction}`);
          newActiveBar.classList.add("active");
          this.activeIndex = which;

          //clean up after animation is done
          setTimeout(
            (() => {
              if (typeof activeSlide !== "undefined") {
                activeSlide.classList.remove(`slide-${direction}`);
              }
              this.isBusy = false;
            }).bind(this),
            ImageSlider.ANIMATION_TIMING
          );
        }).bind(this),
        100
      );

      // otherwise, just swap the active class to the new slide
    } else {
      if (typeof activeSlide !== "undefined") {
        activeSlide.classList.remove("active");
      }
      if (typeof activeBar !== "undefined") {
        activeBar.classList.remove("active");
      }
      newActiveSlide.classList.add("active");
      newActiveBar.classList.add("active");
      this.activeIndex = which;
    }

    // Auto advance to the next slide?
    if (this.shouldAutoAdvance) this.autoAdvance();
  }

  autoAdvance() {
    if (this.autoAdvanceTimeout) {
      clearTimeout(this.autoAdvanceTimeout);
    }
    this.autoAdvanceTimeout = setTimeout(
      (() => this.advanceForDirection("left")).bind(this),
      ImageSlider.AUTO_ADVANCE_DELAY
    );
  }

  stopAutoAdvance() {
    if (this.autoAdvanceTimeout) {
      clearTimeout(this.autoAdvanceTimeout);
    }
    getEls(".image-slider .bar").forEach((bar) => {
      bar.classList.add("animation-done");
    });
    this.shouldAutoAdvance = false;
  }

  advanceForDirection(direction) {
    const { slides } = this.props;
    let idx;
    let max = parseInt(slides.length, 10) - 1;

    if (!max || max < 1) max = 1;
    switch (direction) {
      case "left":
        idx = this.activeIndex < max ? this.activeIndex + 1 : 0;
        break;
      case "right":
        idx = this.activeIndex > 0 ? this.activeIndex - 1 : max;
        break;
      default:
        return;
    }
    this.selectSlide(idx, direction);
  }

  clickNext() {
    this.stopAutoAdvance();
    this.advanceForDirection("left");
  }

  clickPrev() {
    this.stopAutoAdvance();
    this.advanceForDirection("right");
  }

  swipe(direction) {
    switch (direction) {
      case "left":
        this.clickNext();
        break;
      case "right":
        this.clickPrev();
        break;
      default:
        break;
    }
  }

  onWaitForImageLoad() {
    this.selectSlide(0, false);
    this.autoAdvance();
  }

  render() {
    const { trip, slides, waitForImage } = this.props;
    const tripData = config.trips[trip];
    const navBars = [];

    slides.forEach((slide, idx) => {
      navBars.push(
        <div
          key={idx}
          className="bar"
          onClick={(e) => {
            this.stopAutoAdvance();
            this.selectSlide(idx, "auto");
          }}
        >
          <span />
        </div>
      );
    });

    return (
      <ReactTouchEvents onSwipe={this.swipe}>
        <div className="image-slider focus-1">
          <img
            src={waitForImage}
            className="preload"
            onLoad={this.onWaitForImageLoad}
          />
          <div className="track">
            <div
              className="slides"
              dangerouslySetInnerHTML={{ __html: slides.join("") }}
            />
          </div>
          <div className="controls">
            <PrevNext clickPrev={this.clickPrev} clickNext={this.clickNext} />
            <div className="wrap bars">{navBars}</div>
          </div>
          {tripData.soldOut && (
            <div className="sold-out">
              <Link to={`/${tripData.soldOutReferralTrip}/`}>Sold Out</Link>
            </div>
          )}
        </div>
      </ReactTouchEvents>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/image-slider.js